import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";
import axios from "axios";

import List from "./List";

class ShiftStatuses extends React.Component {
  state = { shiftStatuses: this.props.data };

  render() {
    const { shiftStatuses } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-xs-3">
            <b>Shift Statuses</b>
          </div>
          <div className="col-xs-9">
            <div className="pull-right">
              <a className="btn btn-text" 
                role="button" 
                tabIndex={0}
                onClick={this.handlerAdd}
                onKeyDown={(e) => e.key === "Enter" && this.handlerAdd(e)}
              >
                ADD SHIFT STATUS
              </a>
            </div>
          </div>
        </div>
        <p class="grey-text">
          Shift Statuses can be used to track additional information for shifts
          such as sick, paid time off, no-show, etc.
        </p>

        <List
          data={shiftStatuses}
          onDelete={this.handlerDelete}
          onRemove={this.handlerRemove}
          onSave={this.handlerSave}
        />
      </div>
    );
  }

  handlerAdd = () => {
    const tmp = {
      id: null,
      _id: new Date().getTime(),
      name: "",
      edit: true
    };

    this.setState({ shiftStatuses: [...this.state.shiftStatuses, tmp] });
  };

  handlerRemove = _id => {
    const shiftStatuses = lodash.filter(
      this.state.shiftStatuses,
      d => d._id !== _id
    );
    this.setState({ shiftStatuses });
  };

  handlerDelete = (id, callback) => {
    this.delete(id, callback);
  };

  handlerSave = (id, dataShiftStatus, callback) => {
    if (id) {
      this.update(id, dataShiftStatus, callback);
    } else {
      this.create(dataShiftStatus, callback);
    }
  };

  update = (id, dataShiftStatus, callback) => {
    axios
      .put(`/shift_status/${id}`, dataShiftStatus)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.shiftStatuses, {
          id: id
        });
        const shiftStatuses = this.state.shiftStatuses;
        shiftStatuses[idx] = data;

        this.setState({ shiftStatuses }, () => {
          if (callback) {
            callback(true);
          }
        });

        toastr.success("Shift Status updated");
      })
      .catch(({ response }) => {
        this.handlerError(response);
        if (callback) {
          callback(false);
        }
      });
  };

  create = (dataShiftStatus, callback) => {
    axios
      .post("/shift_status", dataShiftStatus)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.shiftStatuses, {
          _id: dataShiftStatus._id
        });
        const shiftStatuses = this.state.shiftStatuses;
        shiftStatuses[idx] = data;

        this.setState({ shiftStatuses }, () => {
          if (callback) {
            callback(true);
          }
        });

        toastr.success("Shift Status created");
      })
      .catch(({ response }) => {
        this.handlerError(response);
        if (callback) {
          callback(false);
        }
      });
  };

  delete = (id, callback) => {
    axios
      .delete(`/shift_status/${id}`)
      .then(({ data }) => {
        const shiftStatuses = lodash.filter(
          this.state.shiftStatuses,
          d => d.id !== id
        );

        this.setState({ shiftStatuses }, () => {
          if (callback) {
            callback(true);
          }
        });
        
        toastr.success("Shift Status deleted");
      })
      .catch(({ response }) => {
        this.handlerError(response);
        if (callback) {
          callback(false);
        }
      });
  };

  handlerError = response => {
    if (response && response.data && response.data.messages) {
      toastr.error(response.data.messages.join("<br/>"));
    }
  };
}

ShiftStatuses.propTypes = {
  data: PropTypes.array.isRequired
};

export default ShiftStatuses;
